import React, { Component } from 'react';
import Vas from '../Vas';
import '../css/Tariffing.css';
import { LinkButton } from 'component-lib';

class ErrorOffline  extends Component {

    //#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
    }

    render()
    {
        let text = Vas.Resources.Labels["ErrorOffline"];
        if(localStorage.getItem('Error')){
          text = localStorage.getItem('Error');
        }

        return (<div className="TariffingContainer" >
          <div 
            className={"tariffingform"} 
            style={{ textAlign:'left' }}>
            <br />
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Titles["Error"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                    <td style={{ fontSize:'14px'}}>{text}</td>  
                </tr>
                <tr>
                  <td style={{ fontSize:'14px' }}>
                    <LinkButton 
                      Text={Vas.Resources.Labels["Startpage"]} 
                      Id={"LinkLogin"} 
                      OnClick={()=>{
                        if(localStorage.getItem('Error')){
                          localStorage.removeItem('Error');
                        }
                        Vas.GetView("Tariffing",null,false);
                      }} />
                  </td>
                </tr>
              </tbody>
            </table> 
            </div>
        </div>);
    }
}
export default ErrorOffline;
